import { defineComponent } from "vue";
import useRoomInfo from "./useRoomInfoHooks.mjs";
import SvgIcon from "../../common/base/SvgIcon.vue.mjs";
import ArrowUpIcon from "../../common/icons/ArrowUpIcon.vue.mjs";
import copyIcon from "../../common/icons/CopyIcon.vue.mjs";
import RoomTime from "../../common/RoomTime.vue.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "RoomInfoH5",
  setup(__props) {
    const {
      t,
      isWeChat,
      arrowDirection,
      handleCloseRoomInfo,
      isShowRoomInfo,
      isShowRoomInfoTitle,
      conferenceTitle,
      roomInfoTabList,
      toggleShowRoomInfoStatus,
      onCopy
    } = useRoomInfo();
    return { __sfc: true, t, isWeChat, arrowDirection, handleCloseRoomInfo, isShowRoomInfo, isShowRoomInfoTitle, conferenceTitle, roomInfoTabList, toggleShowRoomInfoStatus, onCopy, SvgIcon, Arrow: ArrowUpIcon, copyIcon, RoomTime };
  }
});
export {
  _sfc_main as default
};
